// TODO: re-examine this, it was made quickly to hit milestone.
import React from 'react';
import clsx from 'clsx';

const StackedCTA = ({
  callout,
  headline,
  copy,
  children,
  Media,
  mediaLeft = false,
}) => {
  return (
    <div className="relative overflow-hidden">
      <div className="relative ">
        <main className="mx-auto pb-8">
          <h1 className="mt-1 block text-4xl tracking-tight font-extrabold">
            <span className="block text-gray-900">{headline}</span>
          </h1>
          <div className="mt-4">
            <div className="mb-8 lg:col-span-6 lg:flex items-center ">
              <div className="w-full aspect-video my-auto rounded-lg shadow-lg">
                <div className="bg-white rounded-lg overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  {<Media />}
                </div>
              </div>
            </div>
            <div
              className={clsx(
                { 'order-2': mediaLeft },
                'lg:col-span-6 lg:text-left'
              )}
            >
              {/* <h1>
                <span className="block text-sm font-semibold uppercase tracking-wide text-gray-500 sm:text-base lg:text-sm xl:text-base">
                  {callout}
                </span>
                <span className="mt-1 block text-4xl tracking-tight font-extrabold">
                  <span className="block text-gray-900">{headline}</span>
                </span>
              </h1> */}
              <p className="mt-3 text-base text-gray-500 sm:mt-5">{copy}</p>
              <div className="sm:mx-auto lg:text-left lg:mx-0">{children}</div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default StackedCTA;
